import Select from "@/common/components/Select";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipmentCategories } from "@/features/equipments/hooks/useEquipmentCategories";
import { EquipmentCategoryData } from "@/features/equipments/types/equipments.type";

const DashboardFilterEquipmentCategoryHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentCategoriesOptions,
  } = useEquipmentCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<EquipmentCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <Select
      label="Selecione a categoria do equipamento"
      markAsRequired
      options={equipmentCategoriesOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterEquipmentCategoryHiddenFilter;
